import { useStore } from './useStore'
import { useMemo } from 'react';


const insuranceTypes = Object.freeze({
    VEHICLE: 'VEHICLE',
    MORTGAGE: 'MORTGAGE',
    OTHER: 'OTHER'
});

const useAllowedFileTypes = (insuranceType) => {
    const { state } = useStore();
    const acceptedTypes = useMemo(() => {
        if (process.env.GATSBY_IS_ConvertAllImageTypesToTif == "true") {
            return "application/pdf, image/tiff, image/jpeg, image/heic, image/heif"
        }
        switch (insuranceType) {
            case insuranceTypes.VEHICLE:
                return state.borrower.MustAttachProofOfInsurance ? "application/pdf, image/tiff" : "application/pdf, image/tiff, image/jpeg";
            case insuranceTypes.MORTGAGE:
                return "application/pdf, image/tiff";
            case insuranceTypes.OTHER:
                return "application/pdf, image/tiff, image/jpeg";
            default:
                return "application/pdf, image/tiff, image/jpeg";
        }
    }, [insuranceType])
    return acceptedTypes;
}

export { useAllowedFileTypes, insuranceTypes }